/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tag_SaleInputs */

const cs_tag_sale = /** @type {(inputs: Tag_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodej`)
};

const en_tag_sale = /** @type {(inputs: Tag_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sale`)
};

/**
* | output |
* | --- |
* | "Sale" |
*
* @param {Tag_SaleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tag_sale = /** @type {((inputs?: Tag_SaleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tag_SaleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tag_sale(inputs)
	return cs_tag_sale(inputs)
});